import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getMatchPreference, updateMatchPreferences, UpdateMatchPreferencesInput } from '@uplift/api';
import { BaseQueryOpts } from './baseTypes';


export const useMatchPreferenceQuery = (matchId: string, opts?: BaseQueryOpts) => {
  return useQuery({
    queryKey: [ 'match', matchId, 'preference' ],
    queryFn: () => getMatchPreference(matchId),
    select: data => data.data,
    ...opts,
  });
};


export const useUpdateMatchPreferencesMutation = (matchId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [ 'updateMatchPreference' ],
    mutationFn: (preferences: UpdateMatchPreferencesInput) => updateMatchPreferences(matchId, preferences),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [ 'match', matchId, 'preference' ] });
    }
  });
};
